<template>
  <div>
    <a class="action ant-dropdown-link user-dropdown-menu" @click="showamountEnterprise">
      <span class="size-10 mr-2"></span><a-icon type="search" />
    </a>
    <a-modal :width="800" v-model="leafletsible" style="top: 20px" title="师傅查询" okText="查询" @ok="handleSubmit">
      <a-form :form="form">
        <a-form-item style="display: none">
          <a-input v-decorator="['id']" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="省">
          <a-select @change="handleChange4" v-model="provinceCode">
            <!--                           v-decorator="['provinceCode', {rules: [{ required: false, message: '请选择企业名称'}]}]"-->

            <a-select-option v-for="item of selectAllProvinces" :key="item.provinceCode" :value="item.provinceCode">{{
              item.provinceName
            }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="市">
          <a-select @change="handleChange3" v-model="cityCode">
            <!--                         v-decorator="['cityCode', {rules: [{ required: false, message: '请选择企业名称'}]}]"-->

            <a-select-option v-for="item of selectCityNames" :key="item.cityCode" :value="item.cityCode">{{
              item.cityName
            }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区">
          <a-select @change="handleChange2" v-model="areaCode">
            <!--                         v-decorator="['areaCode', {rules: [{ required: false, message: '请选择企业名称'}]}]"-->

            <a-select-option
              v-for="item of selectAreaNames"
              :key="item.areaCode"
              :label="item.areaName"
              :value="item.areaCode"
              >{{ item.areaName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务类别">
          <a-select
            @change="handleChange"
            v-decorator="['installType', { rules: [{ required: true, message: '请选择服务类别' }] }]"
          >
            <a-select-option v-for="item of installTypes" :title="item.dictLabel" :key="item.dictValue">{{
              item.dictLabel
            }}</a-select-option>
          </a-select>
        </a-form-item>

        <!--<icon-text if="this.ids !== 0">-->
        <!--{{xinxi}}-->
        <!--</icon-text>-->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有无师傅" v-if="ids != 0">
          <a-input v-model="xinxi" v-if="ids == 1" style="color: red" />
          <a-input v-model="xinxi" v-if="ids == 2" style="color: green" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getdemandlist } from '@/api/order/NewlyaddedOrderList'
import { LockanRadar } from '@/components'
import EnterpriseDetails from '@/views/enterprise/EnterpriseDetails'
import requirementsEnterpriseModel from '@/views/order/modules/requirementsEnterpriseModel'
import pick from 'lodash.pick'
import store from '@/store'
import {
  countMasterForEnterprise,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getfinddictAll
} from '@/api/order/orderList'
import {
  getselectAreaPrincipalList,
  getselectAreaPrincipalByCityId,
  getselectPriceName,
  getmasterList,
  getupdateOrderMasterInfo,
  gethistoryMaster,
  getselectPriceNameForFirstPage,
  getmasterListForFirstPage
} from '@/api/order/leafletsDistribute'
import { getselectCombox } from '@/api/order/NewlyaddedOrderList'
import IconText from '../list/search/components/IconText'
import ATextarea from 'ant-design-vue/es/input/TextArea'
export default {
  name: 'amountEnterprise',
  components: {
    ATextarea,
    IconText,
    EnterpriseDetails,
    LockanRadar,
    requirementsEnterpriseModel,
    // editOrderModel,
    editOrderModel: () => import('@/views/order/modules/editOrderModel')
    // 注册弹框组件
  },
  data() {
    return {
      ids: 0,
      xinxi: '',
      peopletype: '',

      provinceCode: '',
      cityCode: '',
      areaCode: '',

      selectAreaNames: [],
      districtId: '',

      selectCityNames: [],
      cityId: '',

      selectAllProvinces: [],
      provinceId: '',

      installTypes: [],
      installType: '',
      form: this.$form.createForm(this),
      selectCombox: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      dividerdis: false,
      leafletsible: false,
      searchParam: '',
      chartRadarible: false,
      enterpriseId: '',

      distributedata: []
    }
  },
  methods: {
    // 区
    handleChange2(value) {
      this.districtId = value
    },

    // 市
    handleChange3(value) {
      ;(this.districtId = ''), (this.selectAreaNames = []), (this.areaCode = ''), console.log('value', value)
      this.cityId = value
      getselectAreaName({ cityCode: value }).then(res => {
        if (res.code === 0) {
          /* console.log(res)*/
          this.selectAreaNames = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 省
    handleChange4(value) {
      ;(this.selectCityNames = []),
        (this.selectAreaNames = []),
        (this.cityId = ''),
        (this.districtId = ''),
        (this.cityCode = ''),
        (this.areaCode = ''),
        console.log('value', value)
      this.provinceId = value
      getselectCityName({ provinceCode: value }).then(res => {
        if (res.code === 0) {
          /* console.log(res)*/
          this.selectCityNames = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 服务类别
    handleChange(value) {
      console.log('value', value)
      this.installType = value
    },
    async showcreeated() {
      let dictTypes = ['install_type']
      await getfinddictAll({ dictTypes: dictTypes.join() }).then(res => {
        this.installTypes = res.install_type
      })
      await getselectAllProvince().then(res => {
        if (res.code === 0) {
          /* console.log('aaaaaaaaaaaaa') console.log(res)*/
          this.selectAllProvinces = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    handleSubmit() {
      if (this.installType == '') {
        this.$message.error('请选择服务类别')
      } else {
        countMasterForEnterprise({
          installType: this.installType,
          provinceId: this.provinceId,
          cityId: this.cityId,
          districtId: this.districtId
        }).then(res => {
          if (res.code === 0) {
            if (res.data === 0) {
              this.ids = 1
              this.xinxi = '该地区暂无师傅'
              // this.$message.error('该地区暂无师傅')
            } else {
              this.ids = 2
              this.xinxi = '该地区有师傅'
              // this.$message.success('该地区有师傅')
            }
            console.log('res', res)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },

    // 点击菜单搜索进入此页面
    showamountEnterprise() {
      this.ids = 0
      ;(this.provinceCode = ''),
        (this.cityCode = ''),
        (this.areaCode = ''),
        (this.selectAreaNames = []),
        (this.districtId = ''),
        (this.selectCityNames = []),
        (this.cityId = ''),
        (this.selectAllProvinces = []),
        (this.provinceId = ''),
        (this.installTypes = []),
        (this.installType = ''),
        this.form.resetFields()
      this.showcreeated()
      this.leafletsible = true
      this.enterpriseId = undefined
    },
    amountEnterpriseibleSubmit() {}
  },
  async created() {
    this.peopletype = store.getters.userType
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
